module.exports = __webpack_public_path__ + "img/logo_large.9bd3082b.svg";